import { ApiHandler, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { ApiParameter, HasPagingParameters } from "@insite/client-framework/Services/ApiService";
import {
    chain,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Components/FindLocationModal/Handlers/LoadWarehouses";
import { WarehouseCollectionModel } from "@insite/client-framework/Types/ApiModels";

export interface GetWarehousesApiParameter extends ApiParameter, HasPagingParameters {
    search: string;
    latitude: number;
    longitude: number;
    radius?: number;
    onlyPickupWarehouses?: boolean;
    excludeCurrentPickupWarehouse?: boolean;
    expand?: string[];
}

type HandlerType = ApiHandler<GetWarehousesApiParameter, WarehouseCollectionModel>;

export const PopulateApiParameterUpdated: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
    props.apiParameter.expand = ["properties"];
};

replaceInChain(chain, PopulateApiParameter, PopulateApiParameterUpdated);
